<sh-form-group
  [invalid]="isControlInvalid$ | async"
  [required]="isControlRequired$ | async"
  [label]="label"
  [labelIcons]="labelIcons"
  [helpText]="helpText"
  [currentActionItems]="currentActionItems"
  [describeLabelId]="describeLabelId"
  [errorMsg]="errorMsg ? errorMsg : (innerErrorMessage$ | async)"
  [id]="controlId"
  [formGroupStyling]="formGroupStyling"
  >
  <div slot="inputPrefix">
    <ng-content></ng-content>
  </div>

  @if (canBeIndeterminate) {
    <sh-form-number-complex-base
      [formControl]="control"
      [id]="controlId"
      [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
      [required]="isControlRequired$ | async"
      [min]="min"
      [max]="max"
      [step]="step"
      [placeholder]="placeholder"
      [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
      [invalid]="isControlInvalid$ | async"
      [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
      [indeterminateMsg]="indeterminateMsg"
      [title]="disabledMsg"
      >
    </sh-form-number-complex-base>
  } @else {
    <sh-form-number-base
      class="sh-form-group__input"
      [formControl]="control"
      [id]="controlId"
      [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
      [required]="isControlRequired$ | async"
      [min]="min"
      [max]="max"
      [step]="step"
      [placeholder]="placeholder"
      [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
      [invalid]="isControlInvalid$ | async"
      [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
      [title]="disabledMsg"
      >
    </sh-form-number-base>
  }

</sh-form-group>
